import React from "react"
import {Route} from "react-router-dom";

import DepositView from "./DepositView";
import Deposit from "./Deposit";
import DepositEdit from "./DepositEdit";
import DepositTest from "./DepositTest";

class Deposits extends React.Component {
  render() {
    return <React.Fragment>
      <Route path="/deposits" exact={true} component={DepositView}/>
      <Route path="/deposits/:id" exact={true} component={({match})=><Deposit depo_id={match.params.id}/>}/>
      <Route path="/deposits/:id/edit" exact={true} component={({match})=><DepositEdit depo_id={match.params.id}/>}/>
      <Route path="/deposits/:id/test" exact={true} component={({match})=><DepositTest/>}/>
    </React.Fragment>
  }
}

export default Deposits


// WEBPACK FOOTER //
// ./src/components/Deposits/index.js